const languageList = [
	{ label: "All Languages", value: "" },
	{ label: "Afrikaans", value: "af" },
	{ label: "Albanian", value: "sq" },
	{ label: "Amharic", value: "am" },
	{ label: "Arabic", value: "ar" },
	{ label: "Armenian", value: "hy" },
	{ label: "Azerbaijani", value: "az" },
	{ label: "Basque", value: "eu" },
	{ label: "Bengali", value: "bn" },
	{ label: "Bulgarian", value: "bg" },
	{ label: "Burmese", value: "my" },
	{ label: "Catalan", value: "ca" },
	{ label: "Chinese", value: "zh" },
	{ label: "Croatian", value: "hr" },
	{ label: "Czech", value: "cs" },
	{ label: "Danish", value: "da" },
	{ label: "Dutch", value: "nl" },
	{ label: "English", value: "en" },
	{ label: "Estonian", value: "et" },
	{ label: "Filipino", value: "tl" },
	{ label: "Finnish", value: "fi" },
	{ label: "French", value: "fr" },
	{ label: "Galician", value: "gl" },
	{ label: "Georgian", value: "ka" },
	{ label: "German", value: "de" },
	{ label: "Greek", value: "el" },
	{ label: "Gujarati", value: "gu" },
	{ label: "Hebrew", value: "he" },
	{ label: "Hindi", value: "hi" },
	{ label: "Hungarian", value: "hu" },
	{ label: "Icelandic", value: "is" },
	{ label: "Indonesian", value: "id" },
	{ label: "Irish", value: "ga" },
	{ label: "Italian", value: "it" },
	{ label: "Japanese", value: "ja" },
	{ label: "Kannada", value: "kn" },
	{ label: "Kazakh", value: "kk" },
	{ label: "Khmer", value: "km" },
	{ label: "Korean", value: "ko" },
	{ label: "Lao", value: "lo" },
	{ label: "Latvian", value: "lv" },
	{ label: "Lithuanian", value: "lt" },
	{ label: "Macedonian", value: "mk" },
	{ label: "Malay", value: "ms" },
	{ label: "Malayalam", value: "ml" },
	{ label: "Marathi", value: "mr" },
	{ label: "Mongolian", value: "mn" },
	{ label: "Nepali", value: "ne" },
	{ label: "Norwegian", value: "no" },
	{ label: "Persian", value: "fa" },
	{ label: "Polish", value: "pl" },
	{ label: "Portuguese", value: "pt" },
	{ label: "Punjabi", value: "pa" },
	{ label: "Romanian", value: "ro" },
	{ label: "Russian", value: "ru" },
	{ label: "Serbian", value: "sr" },
	{ label: "Sinhala", value: "si" },
	{ label: "Slovak", value: "sk" },
	{ label: "Slovenian", value: "sl" },
	{ label: "Somali", value: "so" },
	{ label: "Spanish", value: "es" },
	{ label: "Swahili", value: "sw" },
	{ label: "Swedish", value: "sv" },
	{ label: "Tamil", value: "ta" },
	{ label: "Telugu", value: "te" },
	{ label: "Thai", value: "th" },
	{ label: "Turkish", value: "tr" },
	{ label: "Turkmen", value: "tk" },
	{ label: "Ukrainian", value: "uk" },
	{ label: "Urdu", value: "ur" },
	{ label: "Uzbek", value: "uz" },
	{ label: "Vietnamese", value: "vi" },
	{ label: "Welsh", value: "cy" },
	{ label: "Zulu", value: "zu" }
];

export default languageList;